import Box from '@mui/material/Box';
import { textStyles } from './styles';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import TimestampFooter from '../TimestampFooter';
import Typography from '@mui/material/Typography';

const TextBody = ({ message, cleanBody, isOutgoing }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <Typography sx={textStyles(isOutgoing)}>{cleanBody}</Typography>
    <If condition={message.isLastMessageInParticipantBatch}>
      <TimestampFooter
        timestamp={DateTime.fromJSDate(message.timestamp).toLocaleString(
          DateTime.DATETIME_SHORT
        )}
      />
    </If>
  </Box>
);

TextBody.propTypes = {
  isOutgoing: PropTypes.bool.isRequired,
  cleanBody: PropTypes.string.isRequired,
  message: PropTypes.shape({
    body: PropTypes.string.isRequired,
    isLastMessageInParticipantBatch: PropTypes.bool.isRequired,
    timestamp: PropTypes.instanceOf(Date).isRequired
  })
};

export default TextBody;
